import React from 'react';
import { ViewStyle } from 'react-native';
import MapView, { Marker } from 'react-native-maps';

interface Props {
  style?: ViewStyle;
  lat: number;
  lng: number;
}

const MapViewMobile = (props: Props) => (
  <MapView
    provider="google"
    googleMapsApiKey="AIzaSyCN7PcoeNiCHtp6sLL8fxrxStkHReF_U7w"
    style={props.style}
    initialRegion={{
      latitude: props.lat,
      longitude: props.lng,
      latitudeDelta: 0.0922,
      longitudeDelta: 0.0421,
    }}
  >
    <Marker
      coordinate={{
        latitude: props.lat,
        longitude: props.lng,
      }}
    />
  </MapView>
);

export default MapViewMobile;
